import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashLayout from "../components/DashLayout";
import api from "../lib/api";
import { Globe, ExternalLink } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function CustomDomains() {
    const { user } = useAuth();
    const [tunnels, setTunnels] = useState([]);
    useEffect(() => { (async () => {
        const { data } = await api.get("/tunnels");
        setTunnels(data);
    })(); }, []);

    const withDomains = tunnels.filter(t => t.custom_domain);

    return (
        <DashLayout title="CUSTOM DOMAINS" subtitle="dashboard / domains">
            <div className="grid lg:grid-cols-3 gap-0 border border-[#27272A] mb-8">
                <div className="p-6 border-r border-[#27272A] lg:col-span-2">
                    <div className="label-mono text-[#FF9900] mb-2">// PRO FEATURE · DNS WORKFLOW</div>
                    <h3 className="font-display text-2xl font-bold uppercase mb-4">Bring your own domain.</h3>
                    <ol className="space-y-3 text-sm text-[#A1A1AA]">
                        <li><span className="text-[#00FF41] font-mono">1.</span> Go to your tunnel and set a custom domain (e.g. <span className="font-mono text-[#FAFAFA]">api.yourcompany.com</span>).</li>
                        <li><span className="text-[#00FF41] font-mono">2.</span> Add a CNAME record at your DNS provider:</li>
                    </ol>
                    <pre className="mt-4 bg-[#050505] border border-[#18181B] p-4 font-mono text-xs text-[#FAFAFA] overflow-x-auto" data-testid="dns-snippet">
{`Type    Name                Value
CNAME   api                 cname.${user?.tunnel_domain || "synapselink.cloud"}
TTL     300                 (5 minutes)`}
                    </pre>
                    <ol start="3" className="space-y-3 text-sm text-[#A1A1AA] mt-4">
                        <li><span className="text-[#00FF41] font-mono">3.</span> Click <span className="text-[#FAFAFA]">VERIFY DNS</span> on the tunnel page.</li>
                        <li><span className="text-[#00FF41] font-mono">4.</span> SSL is auto-provisioned via Let's Encrypt within ~60 seconds.</li>
                    </ol>
                </div>
                <div className="p-6">
                    <div className="label-mono text-[#00FF41] mb-2">// CNAME TARGET</div>
                    <div className="font-mono text-[#FAFAFA] text-base mb-4 break-all">cname.{user?.tunnel_domain || "synapselink.cloud"}</div>
                    <div className="label-mono mb-2">REGION</div>
                    <div className="font-mono text-[#A1A1AA] text-sm mb-4">global · 14 PoPs</div>
                    <div className="label-mono mb-2">SSL</div>
                    <div className="font-mono text-[#A1A1AA] text-sm">auto · LE wildcard</div>
                </div>
            </div>

            <div className="label-mono mb-3">// CONFIGURED DOMAINS</div>
            {withDomains.length === 0 ? (
                <div className="border border-[#27272A] p-10 text-center" data-testid="no-domains">
                    <Globe className="w-10 h-10 text-[#52525B] mx-auto mb-3" />
                    <p className="text-sm text-[#A1A1AA]">No custom domains attached yet. Open a tunnel and set one in <span className="text-[#FAFAFA]">SETTINGS</span>.</p>
                </div>
            ) : (
                <div className="border border-[#27272A]" data-testid="domain-list">
                    {withDomains.map((t) => (
                        <div key={t.id} className="px-5 py-4 border-b last:border-b-0 border-[#27272A] flex flex-wrap items-center gap-4" data-testid={`domain-row-${t.id}`}>
                            <div className="flex-1 min-w-0">
                                <div className="font-mono text-[#FAFAFA] text-sm truncate">{t.custom_domain}</div>
                                <div className="text-xs text-[#52525B] mt-1">→ {t.public_url ? t.public_url.replace("https://", "") : `${t.subdomain}.synapselink.cloud`}</div>
                            </div>
                            <span className={`text-xs uppercase tracking-wider ${t.custom_domain_status === "active" ? "text-[#00FF41]" : "text-[#FF9900]"}`}>
                                {t.custom_domain_status?.replace("_", " ")}
                            </span>
                            <Link to={`/app/tunnels/${t.id}`} className="tf-btn tf-btn-ghost !py-1.5 !px-3">
                                <ExternalLink className="w-3.5 h-3.5" /> MANAGE
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </DashLayout>
    );
}
